import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

import BannerMessage from "./BannerMessage";
import EliteAlarmsMigrationBanner from "./EliteAlarmsMigrationBanner";

const TopBanners = ({ serverMessage, onHeightChange }) => {
  const ref = useRef(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const updateHeight = () => {
      const height = element.getBoundingClientRect().height;
      onHeightChange(height);
      document.documentElement.style.setProperty(
        "--top-banner-offset",
        `${height}px`
      );
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(element);
    element.querySelectorAll(".banner").forEach((banner) => {
      resizeObserver.observe(banner);
    });

    window.addEventListener("resize", updateHeight);
    window.addEventListener("orientationchange", updateHeight);
    window.visualViewport?.addEventListener("resize", updateHeight);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", updateHeight);
      window.removeEventListener("orientationchange", updateHeight);
      window.visualViewport?.removeEventListener("resize", updateHeight);
    };
  }, [serverMessage, onHeightChange]);

  return createPortal(
    <div ref={ref} className="top-banners">
      <EliteAlarmsMigrationBanner />
      {serverMessage !== null && <BannerMessage message={serverMessage} />}
    </div>,
    document.body
  );
};

export default TopBanners;
